export default "__VITE_ASSET__ziJghZpW__"